import { SystemPrompt } from './prompt';
import { Temperature } from './temperature';
import { Voices } from './voices';

export const AgentTab = () => {
  return (
    <>
      <Voices />
      <SystemPrompt />
      <Temperature />
    </>
  );
};
